import React from 'react';
import { SearchBar } from 'antd-mobile';
import styles from './index.modules.less';

export default (props) => {
  return (
    <div className={styles.container}>
      <SearchBar {...props} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pubBiz/CommonSearchBar/index.js